import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 fs-7"
}
const _hoisted_3 = { class: "svg-icon svg-icon-2 svg-icon-success me-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " You marked Messenger setup as complete. Keep these steps handy if you still need to connect or want to double-check your integration. ", -1)
const _hoisted_5 = { class: "d-flex align-items-start mb-4" }
const _hoisted_6 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4 flex-shrink-0" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h4", { class: "fw-bold mb-2" }, "Connect Messenger for AI replies"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fs-7" }, [
    /*#__PURE__*/_createTextVNode(" Social Fan-out connects your pages for "),
    /*#__PURE__*/_createVNode("strong", null, "posting content"),
    /*#__PURE__*/_createTextVNode(". AI auto-reply needs a separate "),
    /*#__PURE__*/_createVNode("strong", null, "Messenger inbox"),
    /*#__PURE__*/_createTextVNode(" connection in your AI 24/7. ")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<ol class=\"text-gray-700 mb-5 ps-4\"><li class=\"mb-2\">Open your AI 24/7 and go to <strong>Settings → Integrations</strong>.</li><li class=\"mb-2\">Click <strong>Connect</strong> under Facebook &amp; Instagram.</li><li class=\"mb-2\">Log in to Facebook, select your business page, and complete permissions.</li><li class=\"mb-2\">Click <strong>Sync Leads</strong> when prompted.</li><li class=\"mb-0\"> Test with a DM from a <strong>different Facebook account</strong> (not as the page admin). </li></ol><div class=\"alert alert-light-info mb-5 fs-7\"> Posting to Facebook uses the <strong>Social Fan-out</strong> tab. That connection does not receive Messenger DMs. </div>", 2)
const _hoisted_10 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" I've connected Messenger ")
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" I still need to connect ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["card mb-5", _ctx.completed ? 'border border-success' : 'border border-primary border-dashed']
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.completed)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Done-circle.svg" })
            ]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Chat5.svg" })
        ]),
        _hoisted_7
      ]),
      _hoisted_8,
      _createVNode("div", _hoisted_10, [
        _createVNode("button", {
          type: "button",
          class: "btn btn-primary",
          disabled: !_ctx.integrationsUrl || _ctx.loading,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openIntegrations && _ctx.openIntegrations(...args)))
        }, " Open AI 24/7 Integrations ", 8, ["disabled"]),
        (!_ctx.completed)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-light-success",
              disabled: _ctx.completing || _ctx.loading,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('complete')))
            }, [
              (_ctx.completing)
                ? (_openBlock(), _createBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              _hoisted_12
            ], 8, ["disabled"]))
          : (_openBlock(), _createBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-light",
              disabled: _ctx.resetting || _ctx.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('reset')))
            }, [
              (_ctx.resetting)
                ? (_openBlock(), _createBlock("span", _hoisted_13))
                : _createCommentVNode("", true),
              _hoisted_14
            ], 8, ["disabled"]))
      ])
    ])
  ], 2))
}